export default __webpack_public_path__ + "static/media/bg4.f04993e0.svg";